import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MainService } from "../../../../app.service";
import { DependencyTrackVulnerability } from "../../interfaces/dependency-track-vulnerability";
import { DependencyTrackVulnerabilityDetails } from "../../interfaces/dependency-track-vulnerability-details";
import { DependencyTrackVulnerabilityMetrics } from "../../interfaces/dependency-track-vulnerability-metrics";
import { Period } from "../../enums/period";
import { ComponentsResponse } from "../../interfaces/components-response";

@Injectable({
  providedIn: "root",
})
export class DependencyTrackVulnerabilitiesService {
  constructor(
    private httpClient: HttpClient,
    private mainsService: MainService
  ) {}

  getLatestVulnerabilities(projectId: string): Observable<DependencyTrackVulnerability> {
    return this.httpClient.get<DependencyTrackVulnerability>(
      `/dependency-tracker-extractor/v1/projects/${projectId}/vulnerabilities/latest`,
      this.mainsService.httpOptions
    );
  }

  getLatestVulnerabilitiesDetails(
    projectId: string,
    vulnerabilityId: string
  ): Observable<DependencyTrackVulnerabilityDetails> {
    return this.httpClient.get<DependencyTrackVulnerabilityDetails>(
      `/dependency-tracker-extractor/v1/projects/${projectId}/vulnerabilities/${vulnerabilityId}/details/latest`,
      this.mainsService.httpOptions
    );
  }

  getVulnerabilitiesMetrics(
    projectId: string,
    period: Period
  ): Observable<DependencyTrackVulnerabilityMetrics> {
    return this.httpClient.get<DependencyTrackVulnerabilityMetrics>(
      `/dependency-tracker-extractor/v1/projects/${projectId}/vulnerabilities/metrics`,
      { ...this.mainsService.httpOptions, params: { period } }
    );
  }

  getComponentes(
    projectId: string
  ): Observable<ComponentsResponse> {
    return this.httpClient.get<ComponentsResponse>(
      `/dependency-tracker-extractor/v1/projects/${projectId}/components`,
      this.mainsService.httpOptions
    );
  }
}